<template>
  <img src="@/assets/images/spinner.gif" alt="loading" class="w-6 h-6" />
</template>
